import Markdown from "react-markdown";
import { useLocale, useT } from "../i18n";
import { Seo } from "../components/Seo";
import { useSiteSettings } from "../lib/siteSettings";
import { PageHero } from "../components/forms/FormKit";

// Markdown only; react-markdown never renders raw HTML and strips unsafe link protocols.
export default function LegalPage({ page }) {
  const t = useT();
  const lang = useLocale();
  const s = useSiteSettings();
  const body = (s[`${page}_page`]?.[lang] || "").trim();
  return (
    <div data-testid={`${page}-page`}>
      <Seo title={t(`pages.${page}.title`)} description={t(`pages.${page}.description`)} path={page} />
      <PageHero eyebrow={t(`nav.${page}`)} title={t(`pages.${page}.title`)} />
      <section className="bg-white py-16 text-ink lg:py-24">
        <div className="container-x grid lg:grid-cols-12">
          <div className="lg:col-span-8 lg:col-start-3">
            {!s.loaded ? <div className="h-40" aria-busy="true" /> : body ? (
              <div className="legal-prose" data-testid={`${page}-content`}><Markdown skipHtml>{body}</Markdown></div>
            ) : (
              <div className="border-t border-ink/15 py-12" data-testid={`${page}-preparing`}>
                <p className="micro-label text-ink/45">{t("legalPage.preparingTitle")}</p>
                <p className="mt-4 max-w-md text-ink/65">{t("legalPage.preparingBody")}</p>
              </div>
            )}
          </div>
        </div>
      </section>
    </div>
  );
}
